export default store => {
  if (store.callsToAction) {
    return store.callsToAction
  } else if (store.retailer.callsToAction) {
    return store.retailer.callsToAction
  } else {
    return null
  }
}
